import { WindowWithWebviewMethods } from '../types';
import { verifyTokenAndInit } from './tokenUtils';

const initWebViewMethods = () => {
  (window as unknown as WindowWithWebviewMethods).handleLogin =
    function handleLogin(token: string) {
      verifyTokenAndInit(token);
    };
  // window.NativeBridge = {};
  // (window as unknown as WindowWithWebviewMethods).NativeBridge.onLoadComplete =
  //   function onLoadComplete(token: string) {
  //     console.log('ARE YOU BEING CALLED MY G');
  //   };
};

export default initWebViewMethods;
